import {
  SHOW_LOADER,
  HIDE_LOADER,
  SHOW_ERROR,
  CLEAR_ERROR,
  SHOW_MESSAGE,
  CLEAR_MESSAGE,
  SET_ACTION_BAR_SHOW_REMOVE,
  INIT_ACTION_BAR,
  SET_CURRENT_FEATURE,
  GET_CURRENCY_TYPES,
  GET_CURRENCY_TYPES_SUCCESS,
  GET_BANKS,
  GET_BANKS_SUCCESS,
  GET_BANK_REFERENCES,
  GET_BANK_REFERENCES_SUCCESS,
  TRIGGER_UPDATE_NOTIFICATION,
  HIDE_UPDATE_NOTIFICATION,
  CHECK_FOR_UPDATES,
  SET_MAINTENANCE_INFO,
  CLEAR_MAINTENANCE_INFO,
  CHECK_APP_STATUS,
  CHECK_APP_STATUS_SUCCESS,
  CHECK_APP_STATUS_ERROR,
  FINISH_MAINTENANCE,
  FINISH_MAINTENANCE_SUCCESS,
  FINISH_MAINTENANCE_ERROR,
} from '../constants/ActionsTypes'

const initialState = {
  AdminActionBar: {},
  currentFeature: null,
  currencyTypes: null,
  banks: null,
  bankReferences: null,
  headerHeight: 0,
  showUpdateNotification: false,
  latestVersion: '',
  maintenanceInfo: null,
  appStatusLoading: false,
  appStatusChecked: false,
  finishingMaintenance: false,
  finishMaintenanceError: null,
}

function rootReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_LOADER:
      return { ...state, showLoader: true }
    case HIDE_LOADER:
      return { ...state, showLoader: false }
    case SHOW_ERROR:
      return { ...state, error: action.payload }
    case CLEAR_ERROR:
      return { ...state, error: undefined }
    case SHOW_MESSAGE:
      return { ...state, message: action.payload }
    case CLEAR_MESSAGE:
      return { ...state, message: undefined }
    case SET_ACTION_BAR_SHOW_REMOVE:
      return { ...state, AdminActionBar: { showRemove: action.payload } }
    case INIT_ACTION_BAR:
      return { ...state, AdminActionBar: {} }
    case SET_CURRENT_FEATURE:
      return { ...state, currentFeature: action.payload }
    case GET_CURRENCY_TYPES:
      return { ...state, currencyTypes: null }
    case GET_CURRENCY_TYPES_SUCCESS:
      return { ...state, currencyTypes: action.payload.response.data }
    case GET_BANKS:
      return { ...state, banks: null }
    case GET_BANKS_SUCCESS:
      return { ...state, banks: action.payload.response.data }
    case GET_BANK_REFERENCES:
      return { ...state, bankReferences: null }
    case GET_BANK_REFERENCES_SUCCESS:
      return { ...state, bankReferences: action.payload.response.data }
    case TRIGGER_UPDATE_NOTIFICATION:
      return { ...state, showUpdateNotification: true, latestVersion: action.payload }
    case HIDE_UPDATE_NOTIFICATION:
      return { ...state, showUpdateNotification: false }
    case CHECK_FOR_UPDATES:
      return state
    case SET_MAINTENANCE_INFO:
      return { ...state, maintenanceInfo: action.payload }
    case CLEAR_MAINTENANCE_INFO:
      return { ...state, maintenanceInfo: null }
    case CHECK_APP_STATUS:
      return { ...state, appStatusLoading: true }
    case CHECK_APP_STATUS_SUCCESS:
      return { ...state, appStatusLoading: false, appStatusChecked: true }
    case CHECK_APP_STATUS_ERROR:
      return { ...state, appStatusLoading: false, appStatusChecked: true }
    case FINISH_MAINTENANCE:
      return { ...state, finishingMaintenance: true, finishMaintenanceError: null }
    case FINISH_MAINTENANCE_SUCCESS:
      return { ...state, finishingMaintenance: false }
    case FINISH_MAINTENANCE_ERROR:
      return { ...state, finishingMaintenance: false, finishMaintenanceError: action.payload }
    default:
      return state
  }
}

export default rootReducer
